import { Link } from "react-router-dom";
import { categoryStats } from "@/mocks/events";

const categoryIcons: Record<string, string> = {
  社会民生: "ri-community-line",
  商业消费: "ri-shopping-bag-3-line",
  网络传谣: "ri-error-warning-line",
  文娱景区: "ri-landscape-line",
  食品安全: "ri-restaurant-2-line",
  交通出行: "ri-bus-2-line",
};

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-600">
            TOPICS
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            主题分类
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            按事件性质归类，快速找到你正在核实的那一类官方通报与辟谣记录。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoryStats.map((cat) => (
            <Link
              key={cat.name}
              to={`/events?category=${encodeURIComponent(cat.name)}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${categoryIcons[cat.name] || "ri-file-list-3-line"} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-600">
                    {cat.name}
                  </h3>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {cat.count} 件
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}